<template>
  <v-container fluid class="profileDetailContainer">
      <profile-heading-boiler v-if="profile === undefined"></profile-heading-boiler>
      <profile-heading :profile="profile" :avatar-size="85" :show-keyword="true" :show-job-offers="true" v-else></profile-heading>

      <v-tabs v-model="selectedTab">
        <v-tab v-for="tab in tabs" :key="tab">
          {{tab}}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="selectedTab">
        <v-tab-item>
          <profile-lin-updates-boiler v-if="profile === undefined"></profile-lin-updates-boiler>
          <profile-lin-updates :profile="profile" :company-avg="companyAvg" v-else></profile-lin-updates>
        </v-tab-item>
        <v-tab-item>
          <profile-lin-updates-boiler v-if="profile === undefined"></profile-lin-updates-boiler>
          <profile-completion :profile="profile" v-else></profile-completion>
        </v-tab-item>
        <v-tab-item>
          <profile-lin-updates-boiler v-if="jobOffers === undefined"></profile-lin-updates-boiler>
          <profile-job-offers :jobOffers="jobOffers" :job-keyword="jobKeyword" :profile="profile" :jobOffersCounters="jobOffersCounters" v-else></profile-job-offers>
        </v-tab-item>
      </v-tabs-items>
  </v-container>
</template>

<script>
  import api from '@/api/index';
  import ProfileHeading from "../../components/Widgets/profileHeading";
  import ProfileHeadingBoiler from "../../components/Boilerpalettes/profileHeadingBoiler";
  import ProfileLinUpdatesBoiler from "../../components/Boilerpalettes/profileLinUpdatesBoiler";
  import ProfileLinUpdates from "../../components/TabContents/profileLinUpdates";
  import ProfileJobOffers from "../../components/TabContents/profileJobOffers";
  import ProfileCompletion from "../../components/TabContents/profileCompletion";

  const tabs = ['Activity', 'Profile', 'Market'];
    export default {
      name: "Detail",
      components: {
        ProfileCompletion,
        ProfileLinUpdates, ProfileJobOffers, ProfileLinUpdatesBoiler, ProfileHeadingBoiler, ProfileHeading},
      data() {
        return {
          profile: undefined,
          jobOffers: undefined,
          jobOffersCounters: undefined,
          jobKeyword: undefined,
          companyRiskAverage: undefined,
          companyAvg: undefined,
          tabs: tabs,
          selectedTab: tabs[0],
        }
      },
      mounted() {
        this.loadProfile().then(() => {
          this.loadJobKeyword();
        });
        this.loadJobOffers();
        this.loadJobOffersCounters();
        // this.loadCompanyRiskAverage();
        this.loadCompanyEngagementAverage();
      },
      methods: {
        loadProfile() {
          return api.members.getDetails({_id: this.$route.params.id})
            .then(response => {
              this.profile = response.data.data.profile;
            })
        },
        loadJobOffers() {
          api.members.getJobOffers({_id: this.$route.params.id})
            .then(response => {
              this.jobOffers = response.data.data;
            })
        },
        loadJobOffersCounters() {
          api.members.getJobOffersCounters({_id: this.$route.params.id})
            .then(response => {
              this.jobOffersCounters = response.data.data;
            })
        },
        loadJobKeyword(){
          api.jobKeywords.getJobKeyword({jobKeywordId: this.profile.jobSearchTerms[0].jobKeywordId})
            .then(response => {
              this.jobKeyword = response.data.data.jobKeyword;
            })
        },
        // loadCompanyRiskAverage() {
        //   api.clients.getRiskAverage({})
        //   .then(response => {
        //     this.companyRiskAverage = response.data.data.companyAvg;
        //   })
        // },
        loadCompanyEngagementAverage() {
          api.clients.getEngagementAverage({})
          .then(response => {
            this.companyAvg = response.data.data.companyAverage;
          })
        }

      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/staff/Detail.vue